import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// auth
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { AuthGuard } from 'src/auth/guard';
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/main-dashboard/app'));
const File = lazy(() => import('src/pages/dashboard/main-dashboard/file/file'));
const FileDetailPage = lazy(() => import('src/pages/dashboard/main-dashboard/file/file-detail-page'));
const FileManager = lazy(() => import('src/pages/dashboard/file-manager'));
const ProjectManager = lazy(() => import('src/pages/dashboard/project-manager'));
const UserAccountPage = lazy(() => import('src/pages/dashboard/main-dashboard/user/account'));
const UploadPage = lazy(() => import('src/pages/dashboard/upload-manager'));
const FileUploadedPage = lazy(() => import('src/pages/dashboard/main-dashboard/file/file-uploaded-page'));



export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      // { element: <IndexPage />, index: true },
      {
        element: <Navigate to="file" replace />,
        index: true,
      },
      { path: "file", element: <File /> },
      { path: "category-manager", element: <FileManager /> },
      { path: "project-manager", element: <ProjectManager /> },
      { path: "uploads", element: <UploadPage /> },
      { path: 'file/:id', element: <FileDetailPage /> },
      { path: 'total-files-uploaded', element: <FileUploadedPage /> },
      { path: 'profile', element: <UserAccountPage /> },
    ]
  },
];
